<template>
  <main class="c-main">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <header class="card-header">
            <router-link
              :to="{ name: 'productStore',
                                params: {
                                    category_id: $route.params.category_id
                                }
                            }"
              class="btn btn-success"
            >Прикрепить продукт в каталог</router-link>
            <h4 class="pull-right">Продукты</h4>
          </header>
          <div class="card-body">
            <table class="table table-bordered table-striped" id="serverDataTable">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>titleRus</th>
                  <!-- <th>titleUzl</th>
                  <th>titleUzk</th>
                  <th>version</th>-->
                  <th>Код</th>
                  <th>Категория</th>
                  <th>Кол свойств</th>
                  <th>Действие</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(product, index) in products" :key="index">
                  <td>{{ product.id }}</td>
                  <td>{{ product.title }}</td>
                  <!-- <td>{{ product.titleUzl }}</td>
                  <td>{{ product.titleUzk }}</td>
                  <td>{{ product.version }}</td> -->
                  <td>{{ product.code }}</td>
                  <td>{{ categoryTitleRus }}</td>
                  <td>{{ product.fields_count }}</td>
                  <td>
                    <router-link
                      class="btn btn-success"
                      :to="{
                              name: 'fieldsByProduct',
                              params: {
                                  product_id: product.id
                              }
                          }"
                    >+ Свойства</router-link>
                    <router-link
                      class="btn btn-warning"
                      :to="{
                              name: 'categoryUpdate',
                              params: {
                                  category_id: $route.params.category_id,
                                  product_id: product.id,
                              }
                          }"
                    >Изменить</router-link>
                    <a
                      href="javascript:void(0);"
                      @click="deleteProduct(product.id)"
                      class="btn btn-danger"
                    >Удалить</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { GET, DELETE } from "../../shared/api";
export default {
  data() {
    return {
      products: [],
      categoryTitleRus: ""
    };
  },
  methods: {
    getProducts() {
      GET(
        [],
        "/categoryProducts/" + this.$route.params.category_id,
        this,
        false
      ).then(response => {
        this.categoryTitleRus = response.title;
        this.products = response.products;
      });
    },
    deleteProduct(id) {
      DELETE(id, "/product/", this).then(response => {
        this.getProducts();
      });
    }
  },
  mounted() {
    this.getProducts();
  }
};
</script>
